import React from 'react'
import { Tag } from 'antd';

const CircuitButton = ({displays, t}) => {
  return (
    <Tag color="purple" size="small">
        <span style={{fontSize: "small"}}>
            {displays.length}{" "}
            {displays.length > 1 ? t("screens") : t("screen")}
        </span>
    </Tag>
  )
}

export default CircuitButton